import { Filter, TextInput } from "react-admin";
import React from "react";

export const StoreFilter = props => (
    <Filter {...props}>
        <TextInput source="material" label="Material name" defaultValue="" />
    </Filter>
);